import { MetaMask } from '@web3-react/metamask'
import type { Connector } from '@web3-react/types'
import { WalletConnect } from '@web3-react/walletconnect-v2'

export function getName(connector: Connector) {
  if (connector instanceof WalletConnect) return 'WalletConnect'
  if (connector instanceof MetaMask) return 'MetaMask'
  return 'Unknown'
}
